export default __webpack_public_path__ + "static/media/international_vendor.6c7e4565.xlsx";